import { MenuItem } from 'src/utils/shared-types'
import { useState } from 'react'
import { contractpb } from '@ftdr/contract-js-client'

export type Customers = any //Further refinement is needed — include the appropriate type from contractpb.
export interface ExtendedMenuItem extends MenuItem {
  firstName: string
  lastName: string
}
const useCustomersList = () => {
  const [options, setOptions] = useState<ExtendedMenuItem[]>([])

  const createOptions = (data: Customers) => {
    if (data.length === 0) return
    setOptions(
      data.map((customer: { [key: string]: string }) => {
        const customerType = contractpb.ContractCustomerType[+customer.typeCode]
          ? contractpb.ContractCustomerType[+customer.typeCode]
          : null
        const fullName = `${customer.firstName} ${customer.lastName}${
          customerType ? ' (' + customerType + ')' : ''
        }`
        return {
          id: customer.customerID,
          label: fullName,
          value: fullName,
          firstName: customer.firstName,
          lastName: customer.lastName,
        }
      })
    )
  }

  return { options, createOptions }
}

export default useCustomersList
